export default {
  ATLAS_MY_PROPERTY: 'atlasMyProperty',
  ATLAS_OVERVIEW: 'atlasOverview',
  ATLAS_MAP_VIEW: 'atlasMapView',
  ATLAS_OVERVIEW_NEW_DESIGN: 'atlasOverviewNewDesign',
};
